<template>
    <v-container>
      <h2>HISTÓRICO TANQUES</h2>  

      <!-- Históricos de Calibracion -->
      <h2 class="mt-10">HISTÓRICO DE CALIBRACIÓN DE TANQUES</h2>
      <v-card
        class="mt-4"
        color="#a7ecff"
      >
        <v-container class="text-center">
          <v-card>
            <v-btn
              class="ma-3"
              @click="toggleHistory"
              >{{ show_history_cal ? "Ocultar" : "Consultar" }} históricos</v-btn
            >
            <template v-if="show_history_cal">
              <div class="ml-0 mb-4 mt-2 pl-3 pr-3">
                <v-row class="justify-center">
                  <v-col cols="3">
                    <v-select
                      v-model="selected_tank_id"
                      :items="tankList"
                      item-text="name"
                      item-value="id"
                      label="Tanque (opcional)"
                      clearable
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-menu
                      v-model="initTimestampInput_cal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="initTimestamp_cal"
                          label="Fecha inicio"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="initTimestamp_cal"
                        @input="initTimestampInput_cal = false"
                        no-title
                        scrollable
                        first-day-of-week="1"
                        locale="es-ES"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
  
                  <v-col cols="3">
                    <v-menu
                      v-model="endTimestampInput_cal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="endTimestamp_cal"
                          label="Fecha fin"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="endTimestamp_cal"
                        @input="endTimestampInput_cal = false"
                        no-title
                        scrollable
                        first-day-of-week="1"
                        locale="es-ES"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
  
                  <v-col
                    cols="3"
                    style="align-content: center"
                    class="pb-5"
                  >
                    <v-btn
                      @click="getCalibrationHistory"
                      color="#a7ecff"
                      rounded
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
  
              <!-- Tabla de alarmas -->
              <v-data-table
                :headers="headers_calibration"
                :items="history_calibration"
                :loading="loading_history_cal"
                no-data-text="No se han encontrado datos"
              >
                  <template v-slot:item.tank_id="{ item }">
                      {{ formatTank_id(item.tank_id) }}
                  </template>
                  <template v-slot:item.puntos_cal="{ item }">
                    {{ formatPuntos(item.puntos_cal) }}
                  </template>
                  <template v-slot:item.created_at="{ item }">
                    {{ formattedDate(item.created_at)}}
                  </template>
                <template v-slot:no-results>
                  <span>No hay datos para esta búsqueda</span>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-container>
      </v-card>

      <!-- Históricos de tara -->
      <h2 class="mt-10">HISTÓRICO DE TARADO DE TANQUES</h2>
      <v-card
        class="mt-4"
        color="#a7ecff"
      >
        <v-container class="text-center">
          <v-card>
            <v-btn
              class="ma-3"
              @click="toggleHistoryTara"
              >{{ show_history_tara ? "Ocultar" : "Consultar" }} históricos</v-btn
            >
            <template v-if="show_history_tara">
              <div class="ml-0 mb-4 mt-2 pl-3 pr-3">
                <v-row class="justify-center">
                  <v-col cols="3">
                    <v-select
                      v-model="selected_tank_id"
                      :items="tankList"
                      item-text="name"
                      item-value="id"
                      label="Tanque (opcional)"
                      clearable
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-menu
                      v-model="initTimestampInput_tara"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="initTimestamp_tara"
                          label="Fecha inicio"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="initTimestamp_tara"
                        @input="initTimestampInput_tara = false"
                        no-title
                        scrollable
                        first-day-of-week="1"
                        locale="es-ES"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
  
                  <v-col cols="3">
                    <v-menu
                      v-model="endTimestampInput_tara"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="endTimestamp_tara"
                          label="Fecha fin"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="endTimestamp_tara"
                        @input="endTimestampInput_tara = false"
                        no-title
                        scrollable
                        first-day-of-week="1"
                        locale="es-ES"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
  
                  <v-col
                    cols="3"
                    style="align-content: center"
                    class="pb-5"
                  >
                    <v-btn
                      @click="getTaraHistory"
                      color="#a7ecff"
                      rounded
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
  
              <!-- Tabla de alarmas -->
              <v-data-table
                :headers="headers_tara"
                :items="history_tara"
                :loading="loading_history_tara"
                no-data-text="No se han encontrado datos"
              >
                <template v-slot:item.tank_id="{ item }">
                    {{ formatTank_id(item.tank_id) }}
                </template>
                <template v-slot:item.tara_puntos="{ item }">
                    {{ formatPuntos(item.tara_puntos) }}
                </template>
                <template v-slot:item.created_at="{ item }">
                    {{ formattedDate(item.created_at)}}
                </template>
                <template v-slot:no-results>
                  <span>No hay datos para esta búsqueda</span>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-container>
      </v-card>
    </v-container>
  </template>
  
  <script>
  import moment from "moment";
  import "moment-timezone";
  
  import AlarmConfigurationForm from "@/components/forms/AlarmConfigurationForm.vue";
  import AlarmsParameters from "@/components/utils/AlarmsParameters.vue";
  
  import { mapActions } from "vuex";
  
  export default {
    components: {
      AlarmConfigurationForm,
      AlarmsParameters,
    },
  
    data() {
      return {
        id_to_change: [17, 18],

        tankList : [
          {id: 1, name: "Tanque 1"},
          {id: 2, name: "Tanque 2"},
          {id: 3, name: "Tanque 3"},
          {id: 4, name: "Tanque 4"},
          {id: 5, name: "Tanque 5"},
          {id: 6, name: "Tanque 6"},
          {id: 7, name: "Tanque 7"},
          {id: 8, name: "Tanque 8"},
          {id: 9, name: "Tanque 9"},
          {id: 10, name: "Tanque 10"},
          {id: 11, name: "Tanque 11"},
          {id: 12, name: "Tanque 12"},
          {id: 13, name: "Tanque 13"},
          {id: 14, name: "Tanque 14"},
          {id: 15, name: "Tanque 15"},
          {id: 16, name: "Tanque 16"},
          {id: 17, name: "Tanque SE"},
          {id: 18, name: "Tanque SD"},
        ],
        selected_tank_id: null,

        headers_calibration: [
          { text: "Num. Tanque", value: "tank_id" },
          { text: "Puntos de calibración", value: "puntos_cal" },
          { text: "Volumen calibración", value: "volumen_cal" },
          { text: "Fecha", value: "created_at" },
        ],
        show_history_cal: false,
        history_calibration: [],
        loading_history_cal: false,

        initTimestamp_cal: moment(Date.now()).format("YYYY-MM-DD"),
        endTimestamp_cal: moment(Date.now()).add(1, "days").format("YYYY-MM-DD"),
        initTimestampInput_cal: false,
        endTimestampInput_cal: false,

        headers_tara: [
          { text: "Num. Tanque", value: "tank_id" },
          { text: "Puntos de tarado", value: "tara_puntos" },
          { text: "Fecha", value: "created_at" },
        ],
        show_history_tara: false,
        history_tara: [],
        loading_history_tara: false,

        initTimestamp_tara: moment(Date.now()).format("YYYY-MM-DD"),
        endTimestamp_tara: moment(Date.now()).add(1, "days").format("YYYY-MM-DD"),
        initTimestampInput_tara: false,
        endTimestampInput_tara: false,
  
      };
    },
  
    methods: {
      ...mapActions(["getData"]),

      formatTank_id(id){
        return this.id_to_change.includes(id) ? id == 17 ? "SE" : "SD" : id;
      },
      formatPuntos(val) {
        return Math.floor(val);
      },
        // Calibracion
      async toggleHistory() {
        this.show_history_cal = !this.show_history_cal;
        this.selected_tank_id = null;
        if (this.show_history_cal) await this.getCalibrationHistory();
      },
      async getCalibrationHistory() {
        this.loading_history_cal = true;
        const params = {
          initTimestamp: new Date(`${this.initTimestamp_cal} 00:00:00`).toISOString(),
          endTimestamp: new Date(`${this.endTimestamp_cal} 23:59:59`).toISOString(),
        };
        if (this.selected_tank_id) {
          params.tank_id = this.selected_tank_id;
        }
        // console.log("busqueda de historico calibracion", params);
        const { history } = await this.getData({ path: "tanks/calibracion", params: params });
        this.history_calibration = history;
        this.loading_history_cal = false;
      },

      //tarado
      async toggleHistoryTara() {
        this.show_history_tara = !this.show_history_tara;
        this.selected_tank_id = null;
        if (this.show_history_tara) await this.getTaraHistory();
      },
      async getTaraHistory() {
        this.loading_history_tara = true;
        const params = {
          initTimestamp: new Date(`${this.initTimestamp_tara} 00:00:00`).toISOString(),
          endTimestamp: new Date(`${this.endTimestamp_tara} 23:59:59`).toISOString(),
        };
        if (this.selected_tank_id) {
          params.tank_id = this.selected_tank_id;
        }
        // console.log("busqueda de historico calibracion", params);
        const { history } = await this.getData({ path: "tanks/tara", params: params });
        this.history_tara = history;
        this.loading_history_tara = false;
      },

      formattedDate(date) {
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
      }
    },
  
    async mounted() {
    },
  };
  </script>
  